/**
 * HardwareInstance — R3F component rendering a single hardware model at a computed placement.
 */

import { useMemo } from 'react';
import * as THREE from 'three';
import type { HardwarePlacement } from '@/lib/hardware-placement/types';

interface HardwareInstanceProps {
  gltfScene: THREE.Group;
  placement: HardwarePlacement;
  scale: number;
}

export default function HardwareInstance({ gltfScene, placement, scale }: HardwareInstanceProps) {
  const clonedScene = useMemo(() => gltfScene.clone(), [gltfScene]);

  const position: [number, number, number] = [
    placement.position.x,
    placement.position.y,
    placement.position.z,
  ];

  const rotation = new THREE.Euler(
    placement.rotation.x,
    placement.rotation.y,
    placement.rotation.z,
  );

  const scaleArray: [number, number, number] = placement.mirrored
    ? [-scale, scale, scale]
    : [scale, scale, scale];

  return (
    <primitive
      object={clonedScene}
      position={position}
      rotation={rotation}
      scale={scaleArray}
    />
  );
}
